








import Vue from 'vue'
export default Vue.extend({
    props: {
        id: Number,
        startingText: String
    },
    data(){
        return {
            t: ""
        }
    },
    computed: {
        preview(){
           return this.$data.t.replace(/\|(.*?)\|\((.*?)\)/g, "<a href='$1'>$2</a>").replace(new RegExp("__(.*?)__", "g"), "<i>$1</i>").replace(new RegExp("\\*\\*(.*?)\\*\\*", "g"), "<b>$1</b>").replace(new RegExp("##(.*?)##", "g"), "<u>$1</u>");       
        }
    },
    created(){
        if((this as any).$props.startingText){           
            (this as any).$data.t = (this as any).$props.startingText;
        }
    },
    methods: {
        update(){
            console.log(this.$props.startingText);
            
            this.$emit('emit-text', { text: (this as any).t, id: this.$props.id });
        }
    }
})
